import { Injectable } from "@angular/core";
import { DataService } from "../base-data-services/data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { API_URL } from "common/constants/sm-constants";
import { PackageListModel } from "common/models/page-models/custom-model/package.model";


@Injectable()
export class packageListDataService extends DataService<PackageListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getPackageList,http);
    }


//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance():PackageListModel  {
        return new PackageListModel();
    }

}
